export default class RewardStructureStripeSubscription {
  public price: string;

  constructor(options) {
    this.price = options.price;
  }
}
